import * as React from 'react';
import { Line } from 'react-chartjs-2';
import Chartify from '@shipsy/chartify';

/**
 * chartify's LineData hard-codes `fill: false` from its line theme, so an area chart is
 * its line chart with every dataset filled. Returns a copy: LineData memoises its output.
 */
export const withAreaFill = (lineChartData: any) => ({
  ...lineChartData,
  datasets: (lineChartData.datasets || []).map((dataset: any) => ({ ...dataset, fill: true })),
});

class AreaViz extends React.PureComponent<any, any> {

  render() {
    const { formData, chartData } = this.props;
    const chartifyInstance = new Chartify.LineData(chartData, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();
    return <Line data={withAreaFill(chartifyData.data.lineChartData)} options={chartifyData.options} />;
  }
}

export default AreaViz;
